@if(step !== 2){
  <div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">Move Transaction(s)</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="close()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>

      <div class="row">
          <div class="col">
              <div class="modal-sub-heading">Move transaction(s) from this fundraiser to another fundraiser</div>
          </div>
      </div>
</div>
}

<div class="modal-body custom-material-form p-0">
  @switch(step){
    @case(0){
      <div class="modal-body p-0 mb-4">
        <div class=" d-flex items-title justify-content-between mb-3 w-100">
          <button class="btn btn--paybee modal-outline-button btn--sm text-center mr-3" *ngIf="!isAllSelected" (click)="selectAll()">Select All</button>
          <button class="btn btn--paybee modal-outline-button btn--sm text-center mr-3" *ngIf="isAllSelected" (click)="unSelectAll()">Unselect All</button>
  
          <div class="card__right-side d-flex justify-content-end search">
            <div class="search__icon-wrapper">
              <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Icons/search</title>
                <defs>
                  <rect id="path-1" x="0" y="0" width="726" height="404" rx="8"></rect>
                  <filter id="filter-3">
                    <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                  </filter>
                </defs>
                <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Large" transform="translate(-858.000000, -165.000000)">
                    <rect fill="#f1f1f1" x="0" y="0" width="1024" height="882"></rect>
                    <g id="Card" transform="translate(274.000000, 150.000000)">
                      <mask id="mask-2" fill="white">
                        <use xlink:href="#path-1"></use>
                      </mask>
                      <g id="Rectangle"></g>
                    </g>
                    <g id="Icons/search" transform="translate(858.000000, 165.000000)">
                      <g filter="url(#filter-3)" id="Color">
                        <g>
                          <path d="M8.05514748,-6.92779167e-14 C3.61630998,-6.92779167e-14 0,3.61627943 0,8.05514748 C0,12.4939989 3.61630443,16.1103033 8.05514748,16.1103033 C9.97490799,16.1103033 11.7382908,15.4316646 13.1243348,14.3048316 L18.5754498,19.755941 C18.9008413,20.0813298 19.4305328,20.0813576 19.7559438,19.755941 C20.0813521,19.4305245 20.0813521,18.9095246 19.7559438,18.5841359 L14.3048316,13.1330265 C15.4339396,11.7462769 16.110295,9.97705522 16.110295,8.05514748 C16.110295,3.61627943 12.4939878,-6.92779167e-14 8.05514748,-6.92779167e-14 Z M8.05514748,1.66658281 C11.5932936,1.66658281 14.4437122,4.51697637 14.4437122,8.05514748 C14.4437122,11.5932769 11.593288,14.4437205 8.05514748,14.4437205 C4.51700692,14.4437205 1.66658281,11.5932769 1.66658281,8.05514748 C1.66658281,4.51697637 4.51700137,1.66658281 8.05514748,1.66658281 Z" id="search" fill="#000000" fill-rule="nonzero"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <input [formControl]="search" class="form-control--search" placeholder="Search" />
            <div class="search__icon-wrapper--cross px-1"><span class="cursor-pointer" *ngIf="search.value.length > 0" (click)="resetSearch()">X</span></div>
          </div>
        </div>
        <ng-container *ngFor="let transaction of filteredTransactions | paginate : { itemsPerPage: 7, currentPage: p }; let idx = index">
          <label class="option-wrapper d-flex" for="option-{{ transaction.id }}">
            <div class="option-item-number">
              <span [innerText]="(7 * (p - 1)) + (idx + 1)"></span>
            </div>
            <div class="option-item-checkbox">
              <input
                id="option-{{ transaction.id }}"
                mdbCheckbox
                class="form-check-input--paybee"
                type="checkbox"
                [checked]="transaction.checked"
                (change)="onChange($event, transaction.id)"
              />
            </div>
            <div class="option-item-name pr-4">
              <span [innerHTML]="transaction.payer.name"></span>
            </div>
            <div class="option-item-email pr-4 w-100">
                <span [innerHTML]="transaction.payer.email"></span>
            </div>
            <div class="option-item-amount pr-4">
                <span>{{ transaction.amount | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
            </div>
            <div class="option-item-created">
                <span>{{ getCreated(transaction.created) | activityTimer:idx }}</span>
            </div>
          </label>
        </ng-container>
        <div class="items-bottom justify-content-between mt-3">
          <div class="options-count">
            Total Transactions Count: <span>{{ filteredTransactions.length }}</span>
          </div>
          <pagination-controls class="mt-4 mr-4 option-pagination" *ngIf="filteredTransactions.length >= 7" (pageChange)="p = $event"></pagination-controls>
        </div>
      </div>
      <div class="modal-footer">
        <div class="d-flex w-100 justify-content-end">
          <button type="button" class="btn btn--paybee modal-outline-button btn--md text-center mr-2" (click)="close()">Close</button>
          <button type="button" class="btn btn--paybee btn--black btn--md text-center" [disabled]="!selectedCount"  (click)=" this.step = 1">Move {{ selectedCount }} Transaction(s)</button>
        </div>
      </div>
    }
    @case(1){
      <div class="modal-body p-0 mb-4">
        <mdb-form-control class="form-fill" style="min-width: 450px;">
            <mdb-select [formControl]="fundraiserControl" class="mdb-select" [filter]="true">
              <mdb-option *ngFor="let fund of fundraisers" [value]="fund.id">
                {{fund.displayName}} - by
                {{fund.createdByName || fund.userName || fund.userInfo.name}}</mdb-option>
            </mdb-select>
            <label mdbLabel class="form-label form-label--paybee">Select Fundraiser to move to</label>
          </mdb-form-control>
      </div>
      <div class="modal-footer">
        <div class="d-flex w-100 justify-content-between">
          <button type="button" class="btn btn--paybee modal-outline-button btn--md text-center mr-2" (click)="this.step=0">← Back</button>
          <button type="button" class="btn btn--paybee btn--black btn--md text-center" [disabled]="!this.fundraiserControl.value"  (click)="move()">Move {{ selectedCount }} Transaction(s)</button>
        </div>
      </div>
    }
    @case(2){
      <div class="modal-body p-0 mb-4 pt-5 ng-star-inserted d-flex flex-column">
        <i class="fas fa-check-circle green-text headline-2--weight-900 mb-3"></i>
        <span><b>{{selectedTransactions.length}} Transaction(s)</b> successfully moved to <b>{{moveToP2P.createdByName || moveToP2P.userInfo.name}}</b></span>
      </div>
      <div class="modal-footer border-top-0">
        <div class="d-flex w-100 justify-content-end">
          <button type="button" class="btn btn--paybee modal-outline-button btn--md text-center mr-2" (click)="close()">Close</button>
        </div>
      </div>
    }
  }
</div>
